<template>
  <div>
    <c-tab
      type="vertical"
      :tabItems="tabItems"
      :height.sync="height"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
export default {
  name: 'hazop-plan',
  props: {
    popupParam: {
      type: Object,
      default: () => ({

      }),
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
  data() {
    return {
      editable: true,
      splitter: 5,
      tab: 'planInfo',
      tabItems: [
        { name: 'planInfo', icon: 'edit', label: '평가점수 환산표', component: () => import(`${'./auditResultTable.vue'}`) },
        { name: 'team', icon: 'checklist', label: '감사 결과보고서', component: () => import(`${'./resultReport.vue'}`) },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
    },
  }
};
</script>
